// Angular
import { Pipe, PipeTransform } from '@angular/core';
import {
  DomSanitizer,
  SafeHtml,
  SafeStyle,
  SafeScript,
  SafeUrl,
  SafeResourceUrl,
} from '@angular/platform-browser';
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { digitsArToFa, digitsArToEn, digitsEnToFa, digitsFaToEn , digitsEnToAr, digitsFaToAr } from "@persian-tools/persian-tools";
import { numberToWords } from "@persian-tools/persian-tools";
import {JDate} from 'ngx-persian';
import * as moment from 'jalali-moment';
import { FactorCellModel } from 'src/app/pages/accounting/_models/FactorModel';


/**
 * Sanitize HTML
 */
@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  /**
   * Pipe Constructor
   *
   * @param _sanitizer: DomSanitezer
   */
  // tslint:disable-next-line
  constructor(protected _sanitizer: DomSanitizer) {}

  /**
   * Transform
   *
   * @param value: string
   * @param type: string
   */
  transform(
    value: string,
    type: string
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case 'html':
        return this._sanitizer.bypassSecurityTrustHtml(value);
      case 'style':
        return this._sanitizer.bypassSecurityTrustStyle(value);
      case 'script':
        return this._sanitizer.bypassSecurityTrustScript(value);
      case 'url':
        return this._sanitizer.bypassSecurityTrustUrl(value);
      case 'resourceUrl':
        return this._sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        return this._sanitizer.bypassSecurityTrustHtml(value);
    }
  }
}
@Pipe({ name: 'ToFanumber' })
export class ToFanumber implements PipeTransform {
  transform (number : number){
    let ret = digitsEnToFa(addCommas(number));
    return ret;
  }
}
@Pipe({ name: 'ToRaoundNumber' })
export class RaoundNumber implements PipeTransform {
  transform (number : any){
    let ret = (Math.round(number));
    return ret;
  }
}
@Pipe({ name: 'wordsToNumberFa' })
export class wordsToNumberFa implements PipeTransform {
  transform (number : any){
    let ret = digitsEnToFa(number);
    return ret;
  }
}
@Pipe({ name: 'DateToJalali' })
export class DateToJalali implements PipeTransform {
  transform (date : Date){
    // JDate.parse(date)
    let ret = date.toLocaleDateString("fa-IR");
    return ret;
  }
}
@Pipe({
  name: 'jalali'
})
export class JalaliPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let MomentDate = moment(value, 'YYYY/MM/DD');
    return digitsEnToFa(MomentDate.locale('fa').format('YYYY/M/D')) ;
  }
}
@Pipe({
  name: 'UnitType'
})
export class UnitTypePipe implements PipeTransform {
  transform(value: any): any {
    const sss = value;
    switch (sss) {
      case 'SquareMeters': {
        return 'متر مربع'
        
      }
      case 'Box': {
        return 'جعبه'
        break;
      }
      case 'Metr': {
        return 'متر '
        
      }
      case 'Unit': {
        return 'عدد'
       
      }
      case 'Can': {
        return 'حلب/قوطی'
        
      }
      case 'Paket': {
        return 'بسته'
       
      }
      case 'kilogram': {
        return 'کیلو گرم'
        
      }
      case 'gram': {
        return 'گرم'
        
      }
      default:
        return '';
        
    }
  }
}
@Pipe({
  name: 'ActivityType'
})
export class ActivityTypePipe implements PipeTransform {
  transform(value: any): any {
    const sss = value;
    switch (sss) {
      case 'SanadChange': {
        return ' سند'
        
      }
      case 'ClientChange': {
        return ' طرف حساب ها'
        break;
      }
      case 'FactorChange': {
        return ' فاکتور'
        
      }
      case 'ProductCellChange': {
        return ' قطعات اولیه'
       
      }
      case 'ProductBuyChange': {
        return ' محصولات'
       
      }
      case 'FactorBuyChange': {
        return ' فاکتور خرید'
       
      }
      case 'UserAndRollChange': {
        return ' کاربران و دسترسی آنها'
       
      }
      case 'ExpertChange': {
        return 'بازدید'
       
      }
      case 'ManufactoringChange': {
        return 'تولید'
       
      }
      case 'notifications': {
        return 'اطلاعیه ها'
       
      }
      default:
        return '';
        
    }
  }
}
@Pipe({
  name: 'WarrningType'
})
export class WarrningTypePipe implements PipeTransform {
  transform(value: any): any {
    const sss = value;
    switch (sss) {
      case 'FactorNumberWarrning': {
        return 'اخطار شماره فاکتور'
        
      }
      case 'StorageWarrning': {
        return 'کمبود موجودی انبار'
        break;
      }
      case 'FactorWatingWarrning': {
        return 'فاکتور در انتظار تایید '
        
      }
      case 'ExpertWarrning': {
        return 'بازدید جدید'
       
      }
      case 'ManufactoringWarrning': {
        return 'تولید جدید'
       
      }
      case 'ChangeSeqPriceAndValue': {
        return 'تغییر قیمت مواد اولیه'
       
      }
      default:
        return '';
        
    }
  }
}
@Pipe({
  name: 'FactorType'
})
export class FactorTypePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: any): any {
    
    const sss = value;
    switch (sss) {
      case 'PishFactor': {
        const ret = `<span class="badge badge-warning">پیش فاکتور</span>` 
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      case 'Factor': {
        const ret = '<span class="badge badge-success">فاکتور</span>'
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      case 'PendingToAccept': {
        const ret = '<span class="badge badge-secondary">در انتظار تایید</span>'
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      case 'RemoveFactor': {
        const ret = '<span class="badge badge-danger">لغو شده</span>'
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      case 'FactorRasmi': {
        const ret = '<span class="badge badge-info">فاکتور رسمی</span>'
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      
      case 'FactorIsPayOnline': {
        const ret = '<span class="badge badge-dark">پرداخت شده در انتظار تایید</span>'
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      case 'ReturnCellFactor': {
        const ret = '<span class="badge badge-dark">برگشت از فروش</span>'
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      case 'ReturnByeFactor': {
        const ret = '<span class="badge badge-dark">برگشت از خرید</span>'
        return this.sanitizer.bypassSecurityTrustHtml(ret)       
      }
      default:
        return '';
        
    }
  }
}
@Pipe({
  name: 'ChackPrivilage'
})
export class ChackPrivilage implements PipeTransform {
  transform(value: any): any {
    const sss = value;
    switch (sss) {
      case 'Admin': {
        return 'مدیران'
        
      }
      case 'Accountants': {
        return 'حسابداران'
        break;
      }
      case 'Experts': {
        return 'کارشناسان بازدید  '
        
      }
      case 'Manufacturers': {
        return 'همکاران تولید'
       
      }
      case 'CellPartner': {
        return 'همکاران فروش'
       
      }
      default:
        return '';
        
    }
  }
}
@Pipe({
  name: 'FactorStatusPay'
})
export class FactorStatusPayPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: FactorCellModel): any {
    var sum  = value.payments.filter(p=>p.isComplete).reduce((accumulator, object) => {
      return accumulator + object.price;
    }, 0);
    if(value.payments == null || value.payments.length == 0 || sum == 0 ){
      const ret = '<span class="badge badge-danger">در انتظار پرداخت</span>'
      return this.sanitizer.bypassSecurityTrustHtml(ret)   
    }
      
    if(sum < value.factorPrice -1){
      const ret = `<span class="badge badge-warning">تسویه نشده </span>` 
      return this.sanitizer.bypassSecurityTrustHtml(ret)      
    }
    const ret = '<span class="badge badge-success">پرداخت شده</span>'
    return this.sanitizer.bypassSecurityTrustHtml(ret)
  }
}
@Pipe({
  name: 'StoreType'
})
export class StoreTypePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: number): any {
    const sss = value;
    if (sss > 0){
      const ret = '<span class="badge badge-success">رسید انبار</span>';
      return this.sanitizer.bypassSecurityTrustHtml(ret);
    }else {
        const ret = '<span class="badge badge-danger">خروج انبار</span>';
        return this.sanitizer.bypassSecurityTrustHtml(ret);
    }
  }
}
